import { useMemo } from 'react';
import { AllBrandsStatsResponse } from '../../../../shared/models/projects/stats/AllBrandsStatsResponse';
import { TagsResponse } from '../../../../shared/models/tags/TagsResponse';
import { resolveBrandKey } from '../../../../shared/helpers/keyword/KeywordHelper';

export const useCurrentBrandGeneralStats = (
  firmName: string,
  allBrandsStatsResponse: AllBrandsStatsResponse[],
  tags: TagsResponse[] | null
) => {
  return useMemo(() => {
    if (!firmName || !allBrandsStatsResponse) {
      return null;
    }

    // Rows are keyed canonically (tag key / normalized lowercase keyword) — resolve firmName first.
    const brandKey = resolveBrandKey(firmName, tags);
    return allBrandsStatsResponse.find((item) => item.keyword === brandKey) || null;
  }, [allBrandsStatsResponse, firmName, tags]);
};
